<template>
    <div class="d-flex align-items-center min-vh-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-5">
                    <div class="card border-0 shadow">
                        <!-- action ด้วยค่าว่าง "" คือการส่ง Form นี้เข้าสู่หน้าปัจจุบัน -->
                        <!-- method POST คือการส่ง Form ให้อยู่ในรูปของ POST เพื่อส่งข้อมูล Form ในพื้นหลังการทำงาน -->
                        <form @submit.prevent="">
                            <h4 class="card-header text-center">เข้าสู่ระบบ</h4>
                            <div class="card-body px-4">
                                <div class="row g-2">
                                    <div class="col-12">
                                        <label for="username" class="col-form-label">ชื่อผู้ใช้งาน:</label>
                                        <input type="text" class="form-control" id="Username" name="Username" v-model="Username" placeholder="username" >
                                    </div> {{Username}}
                                    <div class="col-12">
                                        <label for="password" class="col-form-label">รหัสผ่าน:</label>
                                        <input type="password" class="form-control" id="Password" name="Password" v-model="Password" placeholder="password" >
                                    </div> {{Password}}
                                    <div class="col-12 text-center py-3">
                                        <button class="btn btn-primary d-grid mx-auto w-75" @click="checkUser()">เข้าสู่ระบบ </button>
                                        <button class="btn btn-primary d-grid mx-auto w-75" @click="GoHome()">Home </button>
                                        <router-link class="nav-link" ref="btnBackHome" to="/">กลับหน้าหลัก</router-link>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'

export default {
  name: 'Login',
  components: {

  },
  data () {
    return {
      LoginPass: false,
      Username: '',
      Password: '',
      UserRows: []
    }
  },
  mounted () {

  },
  methods: {
    GoHome () {
      // this.$router.push('/')
      this.UserID = 5
      this.$router.push({ path: '/MBranchs' })
      console.log(this.UserID)
    },
    checkUser () {
      var self = this
      // Query User by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'getdata/logincheck_user.php',
        data: { Username: this.Username, Password: this.Password }
      })
        .done(function (resp) {
          self.UserRows = JSON.parse(resp).response
          console.log('AFTER USER API')
          console.log(JSON.parse(resp))
          console.log(JSON.parse(resp).response)
          console.log(self.UserRows.length)
          // self.$router.push({ path: '/Home' })
          if (self.UserRows.length > 0) {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Login Successfull',
              showConfirmButton: true,
              timer: 1000
            }).then(function (result) {
              self.UserID = self.UserRows[0].UserID
              self.UserName = self.UserRows[0].UserName
              self.OfficialName = self.UserRows[0].OfficialName
              self.$router.push({ path: '/Home' })
            })
          } else {
            Swal.fire({ icon: 'error', text: 'ข้อมูลผู้เข้าใช้งานไม่ถูกต้อง กรุณาตรวจสอบแล้ว Login อีกครั้ง' })
          }
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'Server Error : ข้อมูลผู้เข้าใช้งานไม่ถูกต้อง กรุณาตรวจสอบแล้ว Login อีกครั้ง' })
        })
    }
  }
}
</script>

<style>

</style>
